import logo from "../../logo.svg";

export const Logo = () => <img src={logo} alt="" />;
